// store/aiSmsSuggestions.js
const state = {
  lastSuggestions: [],
  lastInputs: {
    businessType: "",
    smsType: "",
    numberChar: 132,
    keywords: [],
  },
  generatedAt: null,
};

const mutations = {
  SET_SUGGESTIONS(state, { suggestions, inputs }) {
    state.lastSuggestions = suggestions;
    state.lastInputs = { ...inputs };
    state.generatedAt = Date.now();
  },
  CLEAR_SUGGESTIONS(state) {
    state.lastSuggestions = [];
    state.lastInputs = {};
    state.generatedAt = null;
  },
};

const actions = {
  saveSuggestions({ commit }, { suggestions, inputs }) {
    commit("SET_SUGGESTIONS", { suggestions, inputs });
  },
  clearSuggestions({ commit }) {
    commit("CLEAR_SUGGESTIONS");
  },
};

const getters = {
  hasPreviousSuggestions: (state) => state.lastSuggestions.length > 0,
  previousSuggestions: (state) => state.lastSuggestions,
  previousInputs: (state) => state.lastInputs,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
